import { Empty, Radio, Typography } from 'antd'
import type { FolderDimensionOption } from './DimensionMultiBrowsePanel'
import { useBrowsePopover } from './BrowsePopoverContext'

type Props = {
  dimensions: FolderDimensionOption[]
  value?: number
  onChange?: (id: number | undefined) => void
}

function dimensionLabel(dim: FolderDimensionOption): string {
  return dim.is_manual ? '系统目录' : dim.name
}

export function DimensionBrowsePanel({ dimensions, value, onChange }: Props) {
  const popover = useBrowsePopover()

  if (!dimensions.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无虚拟分类" />
  }

  return (
    <Radio.Group
      className="app-browse-dimension-list app-browse-dimension-list--single"
      value={value}
      onChange={(e) => {
        onChange?.(e.target.value as number)
        popover?.close()
      }}
    >
      {dimensions.map((dim) => (
        <label key={dim.id} className="app-browse-dimension-item">
          <Radio value={dim.id} />
          <span className="app-browse-dimension-item-label">{dimensionLabel(dim)}</span>
          {!dim.is_manual ? (
            <Typography.Text type="secondary" className="app-browse-dimension-item-hint">
              虚拟分类
            </Typography.Text>
          ) : null}
        </label>
      ))}
    </Radio.Group>
  )
}
